
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointActiveFilled as ObiWaypointActiveFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-active-filled.js';
 
 
 

 
 export const ObiWaypointActiveFilled = createComponent({
   react: React,
   tagName: 'obi-waypoint-active-filled',
   elementClass: ObiWaypointActiveFilledElement,
   events: {
     
   }
  });
 
 